import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { InsuranceClaimsApiService } from '../pages/hospital/InsuranceClaims/services/insuranceClaimsApi';
import { Organization } from '../pages/hospital/Billing/types';

/**
 * Hook to fetch organizations from the backend
 * @param uuidInvestigation - Investigation UUID (optional, will use currentInvestigation if not provided)
 * @returns [organizations[], loading, error]
 */
export function useOrganizations(uuidInvestigation?: string): [Organization[], boolean, Error | null] {
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    
    const currentInvestigation = useSelector((state: any) => 
        state.investigations.currentInvestigation
    );
    
    const investigationUuid = uuidInvestigation || currentInvestigation?.uuid;
    
    useEffect(() => {
        async function fetchOrganizations() {
            if (!investigationUuid) {
                return;
            }
            
            setLoading(true);
            setError(null);
            
            try {
                const apiService = (window as any).mockApiService || new InsuranceClaimsApiService();
                const orgs = await apiService.getOrganizations(investigationUuid);
                setOrganizations(orgs);
            } catch (err) {
                const error = err instanceof Error ? err : new Error('Failed to fetch organizations');
                setError(error);
                console.error('Error fetching organizations:', err);
            } finally {
                setLoading(false);
            }
        }
        
        fetchOrganizations();
    }, [investigationUuid]);
    
    return [organizations, loading, error];
}

